import React from 'react'
import Label from 'src/components/Label'

// Payment Method Status
export const PaymentMethodStatus = {
  0: 'DEPRECATE',
  1: 'APPROVE',
  DEPRECATE: 0,
  APPROVE: 1,
}

export const getPaymentMethodStatusLabel = (Status) => {
  const PaymentMethodStatus = {
    0: {
      text: 'DEPRECATE',
      color: 'error',
    },
    1: {
      text: 'APPROVE',
      color: 'success',
    },
    DEPRECATE: {
      text: 0,
    },
    APPROVE: {
      text: 1,
    },
  }

  const { text, color } = PaymentMethodStatus[Status]
  return <Label color={color}>{text}</Label>
}

// CashIn Status
export const CashInStatus = {
  0: 'DEPRECATE',
  1: 'APPROVE',
  DEPRECATE: 0,
  APPROVE: 1,
}

export const cashInLockStatuses = [
  {
    id: 0,
    status: false,
    name: 'UNLOCK',
  },
  {
    id: 1,
    status: true,
    name: 'LOCKED',
  },
]

export const cashInCheckStatuses = [
  {
    id: 0,
    status: false,
    name: 'UNCHECK',
  },
  {
    id: 1,
    status: true,
    name: 'CHECKED',
  },
]

export const cashInFinishStatuses = [
  {
    id: 0,
    status: false,
    name: 'UNFINISH',
  },
  {
    id: 1,
    status: true,
    name: 'FINISHED',
  },
]

export const getCashInLockStatusLabel = (islock) => {
  const CashInStatus = {
    0: {
      text: 'UNLOCK',
      color: 'error',
    },
    1: {
      text: 'LOCKED',
      color: 'success',
    },
    SUBMITTED: {
      id: 0,
    },
    CONFIRMED: {
      id: 1,
    },
  }

  if (!islock) {
    const { text, color } = CashInStatus[0]
    return <Label color={color}>{text}</Label>
  }

  const { text, color } = CashInStatus[1]
  return <Label color={color}>{text}</Label>
}

export const getCashInCheckStatusLabel = (isCheck) => {
  const CashInStatus = {
    0: {
      text: 'UNCHECK',
      color: 'error',
    },
    1: {
      text: 'CHECKED',
      color: 'success',
    },
    SUBMITTED: {
      id: 0,
    },
    CONFIRMED: {
      id: 1,
    },
  }

  if (!isCheck) {
    const { text, color } = CashInStatus[0]
    return <Label color={color}>{text}</Label>
  }

  const { text, color } = CashInStatus[1]
  return <Label color={color}>{text}</Label>
}

export const getCashInFinishStatusLabel = (isFinish) => {
  const CashInStatus = {
    0: {
      text: 'UNFINISH',
      color: 'error',
    },
    1: {
      text: 'FINISH',
      color: 'success',
    },
    SUBMITTED: {
      id: 0,
    },
    CONFIRMED: {
      id: 1,
    },
  }

  if (!isFinish) {
    const { text, color } = CashInStatus[0]
    return <Label color={color}>{text}</Label>
  }

  const { text, color } = CashInStatus[1]
  return <Label color={color}>{text}</Label>
}

export const getCourseProductFinishStatusLabel = (isFinish) => {
  const CashInStatus = {
    0: {
      text: 'UNFINISH',
      color: 'success',
    },
    1: {
      text: 'FINISH',
      color: 'error',
    },
    SUBMITTED: {
      id: 0,
    },
    CONFIRMED: {
      id: 1,
    },
  }

  if (!isFinish) {
    const { text, color } = CashInStatus[0]
    return <Label color={color}>{text}</Label>
  }

  const { text, color } = CashInStatus[1]
  return <Label color={color}>{text}</Label>
}

// Product Status
export const ProductStatus = {
  0: 'DEPRECATE',
  1: 'APPROVE',
  DEPRECATE: 0,
  APPROVE: 1,
}

export const getProductStatusLabel = (Status) => {
  const ProductStatus = {
    0: {
      text: 'DEPRECATE',
      color: 'error',
    },
    1: {
      text: 'APPROVE',
      color: 'success',
    },
    DEPRECATE: {
      text: 0,
    },
    APPROVE: {
      text: 1,
    },
  }

  const { text, color } = ProductStatus[Status]
  return <Label color={color}>{text}</Label>
}

// Course Status (=Purchased Service Status) -OrderListView, PurchasedServiceListView
export const CourseStatus = {
  1: 'COMPLETED',
  2: 'CONTINUE',
  3: 'TRANSFER',
  FINISH: 1,
  CONTINUE: 2,
  TRANSFER: 3,
}

export const getCourseStatusLabel = (Status) => {
  const CourseStatus = {
    1: {
      text: 'FINISHED',
      color: 'success',
    },
    2: {
      text: 'CONTINUE',
      color: 'warning',
    },
    3: {
      text: 'TRANSFER',
      color: 'error',
    },
    FINISH: {
      id: 1,
    },
    CONTINUE: {
      id: 2,
    },
    TRANSFER: {
      id: 3,
    },
  }

  const { text, color } = CourseStatus[Status]
  return <Label color={color}>{text}</Label>
}

// Course PaymentStatus
export const CoursePaymentStatus = {
  0: 'PENDING',
  1: 'COMPLETED',
  PENDING: 0,
  COMPLETED: 1,
}

export const getCoursePaymentStatusLabel = (Status) => {
  const CoursePaymentStatus = {
    0: {
      text: 'INCOMPLETED',
      color: 'error',
    },
    1: {
      text: 'COMPLETED',
      color: 'success',
    },
    UNCOMPLETED: {
      text: 0,
    },
    COMPLETED: {
      text: 1,
    },
  }

  const { text, color } = CoursePaymentStatus[Status]
  return <Label color={color}>{text}</Label>
}

//Signature Status
export const SignatureStatus = {
  0: 'UNSIGN',
  1: 'MESSAGE SEND',
  2: 'SIGNED',
  UNSIGN: 0,
  MESSAGESEND: 1,
  SIGNED: 2,
}

export const getSignatureStatusLabel = (Status) => {
  const SignatureStatus = {
    0: {
      text: 'UNSIGN',
      color: 'error',
    },
    1: {
      text: 'MESSAGE SEND',
      color: 'warning',
    },
    2: {
      text: 'SIGNED',
      color: 'success',
    },
    UNSIGN: {
      text: 0,
    },
    MESSAGESEND: {
      text: 1,
    },
    SIGNED: {
      text: 2,
    },
  }

  const { text, color } = SignatureStatus[Status]
  return <Label color={color}>{text}</Label>
}

// Employee Status
export const EmployeeStatus = {
  0: 'DEPRECATE',
  1: 'APPROVE',
  DEPRECATE: 0,
  APPROVE: 1,
}

export const getEmployeeStatusLabel = (Status) => {
  const EmployeeStatus = {
    0: {
      text: 'DEPRECATE',
      color: 'error',
    },
    1: {
      text: 'APPROVE',
      color: 'success',
    },
    DEPRECATE: {
      text: 0,
    },
    APPROVE: {
      text: 1,
    },
  }

  const { text, color } = EmployeeStatus[Status]
  return <Label color={color}>{text}</Label>
}

export const expenseStatus = [
  {
    id: 0,
    status: false,
    name: 'LOCKED',
  },
  {
    id: 1,
    status: true,
    name: 'FINISHED',
  },
]

// ExpenseView Expense Status (locked/ unlock)
export const getExpenseStatusLabel = (Status) => {
  const ExpenseStatus = {
    false: {
      text: 'LOCKED',
      color: 'error',
    },
    true: {
      text: 'FINISHED',
      color: 'success',
    },
    UNLOCK: {
      text: false,
    },
    LOCKED: {
      text: true,
    },
  }

  const { text, color } = ExpenseStatus[Status]
  return <Label color={color}>{text}</Label>
}

// Appointment Status
export const getSearchAppointmentStatus = (Status) => {
  const AppointmentStatus = {
    0: {
      text: 'BOOK',
      color: 'book',
    },
    1: {
      text: 'REMIND',
      color: 'remind',
    },
    2: {
      text: 'CONFIRM',
      color: 'warning',
    },
    3: {
      text: 'CHECK IN',
      color: 'success',
    },
    4: {
      text: 'NO SHOW',
      color: 'error',
    },
    5: {
      text: 'CANCEL',
      color: 'cancel',
    },
    6: {
      text: 'MSG SEND',
      color: 'msgSend',
    },
    BOOK: {
      id: 0,
    },
    REMIND: {
      id: 1,
    },
    CONFIRM: {
      id: 2,
    },
    CHECKIN: {
      id: 3,
    },
    NOSHOW: {
      id: 4,
    },
    CANCEL: {
      id: 5,
    },
    MSGSEND: {
      id: 6,
    },
  }

  const { text, color } = AppointmentStatus[Status]
  return <Label color={color}>{text}</Label>
}
